// extracted by mini-css-extract-plugin
export default {"searchBar":"searchbar_searchBar__LjX0-","searchIcon":"searchbar_searchIcon__ghKlH"};